import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import freightsAPI from '../../api/freights';
import { Types, Creators as FreightCreators } from '../../reducers/freights';
import { setCustomerCep } from '../../utils/cookies';
import getState from '../../utils/getState';

function* productFreightRequest({ cep }) {
  try {
    const {
      product: { currentSku, seller },
      app,
    } = yield select(getState);

    const sku = currentSku.getIn(['id']);
    const domain = app.getIn(['config', 'domain']);
    const siteId = seller.getIn(['id']);

    if (!cep || cep.length < 8) {
      throw new Error('Cep inválido');
    }

    setCustomerCep(cep, domain);

    const data = yield call(freightsAPI.bestFreightsOptions, sku, cep, siteId);

    data.sku = sku;

    yield put(FreightCreators.productFreightSuccess(data));
  } catch (error) {
    const errorObj = formatError(error);
    yield put(
      FreightCreators.productFreightFailed({
        ...errorObj,
        product: true,
      })
    );
  }
}

export default function* watch() {
  yield takeLatest(Types.PRODUCT_FREIGHT_REQUEST, productFreightRequest);
}
